<template>
    <v-container class="px-0">
        <loading v-if="isLoading" :show="isLoading" />
        <v-container v-else-if="mustShowThanksMessage" fluid class="fill-height px-8 thanks-message-container">
            <v-row justify="center" align="center">
                <v-col cols="12" md="8">
                    <div class="card-box text-center">
                        <v-icon size="72" color="#007dc7">mdi-handshake-outline</v-icon>
                        <h2 class="page-title color-grey-onfly">Obrigado pela parceria!</h2>
                        <p class="color-grey-onfly">
                            Nosso time irá analisar os dados e, em breve,
                            as alterações serão refletidas em futuras reservas.
                        </p>
                        <p class="color-grey-onfly">
                            A <strong>Onfly</strong> é imensamente grata pela sua parceria e pela confiança depositada em nós.
                            Essa colaboração é essencial para o crescimento e a prosperidade de ambos.
                            Juntos, construímos melhores negócios e experiências para todos!
                        </p>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-else fluid class="px-2 px-lg-8 hotel-update__form-container">
            <hotel-data
                ref="hotelData"
                v-show="showHotelDataForm"
                :hotel-data="hotelData"
                @confirmed="closeHotelDataForm"
            />
            <rooms
                ref="rooms"
                v-if="hotelRooms !== null"
                v-show="!showHotelDataForm && !showUnavailabilityPeriodsStep"
                :hotel-rooms="hotelRooms"
                :hotel-name="hotelName"
                @go-back="reopenHotelDataForm"
                @next="goToUnavailabilityPeriodsStep"
            />
            <unavailability-periods
                ref="unavailabilityPeriods"
                v-if="hasOpenedUnavailabilityPeriodsStep"
                v-show="!showHotelDataForm && showUnavailabilityPeriodsStep"
                :token-hash="$route.params.tokenHash"
                @go-back="reopenRoomsStep"
                @confirm-sending-form="openHotelUpdateFaresConfirmationModal"
            />
            <confirm-action-dialog
                :title="confirmActionDialog.title"
                :type="confirmActionDialog.type"
                :action-button-label="confirmActionDialog.buttonLabel"
                :model.sync="confirmActionDialog.model"
                :message="confirmActionDialog.message"
                @confirm="confirmActionDialog.action"
            />
            <response-dialog
                :model="responseDialog.dialog"
                :message="responseDialog.message"
                :type="responseDialog.type"
                @close="closeResponseDialogReloadPage"
            />
        </v-container>
    </v-container>
</template>

<script>

import Rooms from "../../components/HotelOwnerActions/UpdateFares/Rooms.vue";
import Loading from "../../components/General/Loading.vue";
import HotelData from "../../components/HotelOwnerActions/UpdateFares/HotelData.vue";
import ConfirmActionDialog from "../../components/Dialog/ConfirmActionDialog.vue";
import UnavailabilityPeriods from "../../components/HotelOwnerActions/UpdateFares/UnavailabilityPeriods.vue";

export default {
    name: "UpdateFares",
    components: {UnavailabilityPeriods, ConfirmActionDialog, HotelData, Loading, Rooms },
    data: () => ({
        hotelRooms: null,
        hotelData: null,
        isLoading: false,
        hotelName: null,
        hotelId: null,
        showHotelDataForm: true,
        showUnavailabilityPeriodsStep: false,
        hasOpenedUnavailabilityPeriodsStep: false,
        mustShowThanksMessage: false,
        confirmActionDialog: {
            title: '',
            type: '',
            buttonLabel: '',
            model: false,
            action: ''
        },
        responseDialog: {
            dialog: false,
            message: '',
            type: null
        },
    }),
    methods: {
        fetchHotelRooms () {
            this.isLoading = true;
            axios.get(`/api/v1/owner-actions/${this.$route.params.tokenHash}/get-hotel-rooms`).then(response => {
                this.hotelName = response.data.name;
                this.hotelId = response.data.id;
                this.hotelRooms = response.data.rooms;
                this.hotelData = {
                    name: response.data.name,
                    contact: response.data.telephone,
                    email: response.data.email,
                    whatsapp: response.data.whatsapp_number,
                    paymentType: response.data.payment_type,
                    pixKey: response.data.pix_key,
                    pixKeyType: response.data.pix_key_type,
                };
                this.isLoading = false;
            });
        },
        closeHotelDataForm () {
            this.showHotelDataForm = false;
        },
        reopenHotelDataForm () {
            this.showHotelDataForm = true;
            this.showUnavailabilityPeriodsStep = false;
        },
        goToUnavailabilityPeriodsStep () {
            this.hasOpenedUnavailabilityPeriodsStep = true;
            this.showUnavailabilityPeriodsStep = true;
        },
        reopenRoomsStep () {
            this.showUnavailabilityPeriodsStep = false;
        },
        getUpdateFaresData () {
            const hotelData = this.$refs.hotelData.getData();
            return {
                id: this.hotelId,
                contact: hotelData.contact,
                whatsapp_number: hotelData.whatsapp_number,
                email: hotelData.email,
                pix_key: hotelData.pix_key,
                pix_key_type: hotelData.pix_key_type,
                rooms: this.$refs.rooms.getData()
            };
        },
        openHotelUpdateFaresConfirmationModal (unavailabilityPeriodsData) {
            this.confirmActionDialog.title = 'Enviar informações';
            this.confirmActionDialog.type = 'info';
            this.confirmActionDialog.buttonLabel = 'Enviar';
            this.confirmActionDialog.message = 'Você realmente deseja enviar? Certifique-se de que as informações estão corretas.';
            this.confirmActionDialog.action = () => this.sendUpdateFaresRequest(unavailabilityPeriodsData);
            this.confirmActionDialog.model = true;
        },
        async sendUpdateFaresRequest (unavailabilityPeriodsData) {
            try {
                const tokenHash = this.$route.params.tokenHash;
                const unavailabilityPeriodsPayload = unavailabilityPeriodsData || {
                    periodsToAdd: [],
                    periodIdsToDelete: []
                };

                const payload = {
                    ...this.getUpdateFaresData(),
                    unavailability_periods: {
                        periods_to_add: unavailabilityPeriodsPayload.periodsToAdd,
                        period_ids_to_delete: unavailabilityPeriodsPayload.periodIdsToDelete,
                    },
                    source: this.$route.query.source || null,
                };

                const response = await axios.patch(
                    `/api/v1/owner-actions/${tokenHash}/update-hotel-data`,
                    payload,
                    { validateStatus: () => true }
                );

                response.data.success
                    ? this.onResponseSuccess(response.data.message)
                    : this.onResponseError(response.data.message);
            } catch (error) {
                this.openResponseDialog('Ocorreu um erro inesperado. Tente novamente, e se o erro persistir, entre em contato conosco', 'error');
            }
        },
        onResponseSuccess (message) {
            this.openResponseDialog(message, 'success');
        },
        onResponseError (message) {
            this.openResponseDialog(message, 'error');
        },
        cleanConfirmationModalData () {
            this.confirmActionDialog.model = false;
            this.confirmActionDialog.title = '';
            this.confirmActionDialog.type = '';
            this.confirmActionDialog.buttonLabel = '';
            this.confirmActionDialog.message = '';
            this.confirmActionDialog.action = null;
        },
        openResponseDialog (message, dialogType) {
            this.cleanConfirmationModalData();
            this.responseDialog.message = message;
            this.responseDialog.type = dialogType;
            this.responseDialog.dialog = true;
        },
        closeResponseDialogReloadPage () {
            this.responseDialog.dialog = false;
            this.responseDialog.type === 'success'
                ? this.showThanksMessage()
                : this.reloadPage();
        },
        showThanksMessage () {
            this.mustShowThanksMessage = true;
        },
        reloadPage () {
            window.location.reload();
            this.$forceUpdate();
        },
    },
    created () {
        this.fetchHotelRooms();
    }
}
</script>

<style lang="scss" scoped>
.color-grey-onfly {
    color: #54667a !important;
}
.page-title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 24px;
}
.card-box {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 48px 32px;
    border: 1px solid lightgrey;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #ffffff;
}
.thanks-message-container {
    margin-top: 6rem;
}

.hotel-update__form-container {
    padding-bottom: 7rem !important;
}

@media screen and (max-width: 960px) {
    .thanks-message-container {
        margin-top: 0;
    }
}
</style>
